import { SET_MATCH_ANALYSIS } from "./actionTypes";

const INITIAL_STATE = {
  match: null,
  odd: null,
  liveOdd: null,
  matchAnalysis: null,
  matchHalfFullAnalysis: null,
  lineupData:  null,
  matchStanding : null,
  matchLatestData : null,
};

const MatchReducer = (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_MATCH_ANALYSIS:
      return {
        ...state,
        match: action.payload.match,
        odd: action.payload.odd,
        liveOdd: action.payload.liveOdd,
        matchAnalysis: action.payload.matchAnalysis,
        matchHalfFullAnalysis: action.payload.matchHalfFullAnalysis,
        lineupData: action.payload.lineupData,
        matchLatestData: action.payload.matchLatestData,
        matchStanding : action.payload.matchStanding,
      };
    default:
      return state;
  }
};

export default MatchReducer;
